import React, { createContext, useContext, useState } from 'react';
import { utils as XLSXUtils, writeFile as XLSXWriteFile } from 'xlsx';

// Create a context
const SearchExportContext = createContext();

// Create a provider component
export const SearchExportProvider = ({ children }) => {
    const [searchTerm, setSearchTerm] = useState('');

    // Function to filter data based on search term
    const filterData = (data) => {
        if (!searchTerm) return data;
        return data.filter(item => {
            return Object.values(item).some(value =>
                String(value).toLowerCase().includes(searchTerm.toLowerCase())
            );
        });
    };

    // Function to export emails as CSV
    const exportEmailsAsCSV = (data) => {
        const csvContent = "data:text/csv;charset=utf-8," +
            data.map(item => item.email).join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "emails.csv");
        document.body.appendChild(link);
        link.click();
    };

    // Function to export data as CSV
    const exportDataAsCSV = (data, fileName) => {
        const headers = Object.keys(data[0]);
        const csvContent = "data:text/csv;charset=utf-8," +
            headers.join(",") + "\n" +
            data.map(item => headers.map(header => item[header]).join(",")).join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `${fileName}.csv`);
        document.body.appendChild(link);
        link.click();
    };

    // Function to export data as XLSX
    const exportDataAsXLSX = (data, fileName) => {
        const ws = XLSXUtils.json_to_sheet(data);
        const wb = XLSXUtils.book_new();
        XLSXUtils.book_append_sheet(wb, ws, "Sheet1");
        XLSXWriteFile(wb, `${fileName}.xlsx`);
    };

    // Function to export data to Google Sheets (dummy function as actual integration would require Google API setup)
    const exportDataToGoogleSheets = (data) => {
        const googleSheetLink = "https://docs.google.com/spreadsheets/create";
        window.open(googleSheetLink, "_blank");
    };

    return (
        <SearchExportContext.Provider value={{
            searchTerm,
            setSearchTerm,
            filterData,
            exportEmailsAsCSV,
            exportDataAsCSV,
            exportDataAsXLSX,
            exportDataToGoogleSheets
        }}>
            {children}
        </SearchExportContext.Provider>
    );
};

// Custom hook to use the context
export const useSearchExport = () => {
    return useContext(SearchExportContext);
};